/**
 * @module DynamicComponent
 */

import React, { useEffect } from 'react';
import config from 'config';

// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import WebpackUtils from '../../utils/WebpackUtils';

/**
 * Dynamic component, a component that takes in a remoteConfig object (see prop details) and uses
 * webpack modules federation plugin to load the component on the client as a React
 * Suspense component. This component renders the passed component asynchronously and also takes in an optional
 * parameter to show a fallback while the component is loading.
 *
 * @param {Object} props
 * @param {Object} props.remoteConfig
 * @param {String} props.remoteConfig.scope
 * @param {String} props.remoteConfig.scope
 * @param {String} props.remoteConfig.scope
 *
 * @return {JSX.Element}
 * @constructor
 */
const DynamicComponent = (props) => {
	const { remoteConfig, fallBackComponent, ...passThrough } = props;

	const LoadedComponent = WebpackUtils.withDynamicScript(
		remoteConfig,
		fallBackComponent,
	);
	useEffect(() => {}, [passThrough]);

	return (
		<React.Suspense fallback={fallBackComponent}>
			<LoadedComponent {...passThrough} env={config.ENV} />
		</React.Suspense>
	);
};

DynamicComponent.propTypes = {
	remoteConfig: PropTypes.object.isRequired,
	fallBackComponent: PropTypes.object,
};

DynamicComponent.defaultProps = {
	fallBackComponent: <div />,
};

export default DynamicComponent;
